import React, { useState } from "react";
import { PiBookOpenUserDuotone, PiListDuotone, PiStar, PiNotebookDuotone, PiPlusCircleDuotone, PiRocketLaunchDuotone, PiYoutubeLogoDuotone } from "react-icons/pi";

export default function WhatsNew() {
  const [filter, setFilter] = useState("Featured");

  // Updated filter types as per requirements
  const filterTypes = [
    { label: "Featured Updates", value: "Featured", icon: PiStar },
    { label: "New Features", value: "New", icon: PiRocketLaunchDuotone },
    { label: "YouTube", value: "YouTube", icon: PiYoutubeLogoDuotone },
    { label: "Resources", value: "Resources", icon: PiBookOpenUserDuotone },
  ];

  // Filter items based on selected filter
  const filteredItems = filter === "Featured"
    ? WHATS_NEW_ITEMS.filter(item => item.tags.includes("Featured"))
      .sort((a, b) => (a.featuredRank || 999) - (b.featuredRank || 999)) // Sort by featuredRank if available
    : WHATS_NEW_ITEMS.filter(item => item.type === filter);
    
  /* Original filter code (commented out)
  const [filter, setFilter] = useState("All");

  const filterTypes = [
    { label: "Featured Updates", value: "All", icon: PiStar },
    { label: "New Features", value: "Feature", icon: PiNotebookDuotone },
    { label: "YouTube", value: "YouTube", icon: PiYoutubeLogoDuotone },
    // { label: "Case Study", value: "Case Study", icon: PiNotebookDuotone },
    { label: "Resources", value: "Documentation", icon: PiBookOpenUserDuotone },
    // { label: "Others", value: "Others", icon: PiPlusCircleDuotone },
  ];

  const filteredItems = WHATS_NEW_ITEMS.filter((item) => filter === "All" || item.type === filter);
  */

  return (
    <div className="min-h-screen bg-gray-50 ">
      <main className="max-w-screen-xl mx-auto px-4  py-28">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-gray-900 mb-2">What's New</h1>
          <p className="text-base text-foreground-500">Stay updated with the latest YourGPT features and resources.</p>
        </div>

        {/* Filter Bar */}
        <div className="flex flex-wrap gap-2 justify-center mb-12">
          {filterTypes.map((type) => (
            <button
              key={type.value}
              onClick={() => setFilter(type.value)}
              className={`inline-flex items-center px-4 py-2 rounded-full text-sm font-medium transition-colors
                ${filter === type.value ? "bg-primary1 text-white" : "bg-white text-gray-700 hover:bg-gray-100"}
                border border-gray-200 shadow-sm`}
            >
              <span className="mr-2">
                <type.icon className="size-5" />
              </span>
              {type.label}
            </button>
          ))}
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredItems.map((item, index) => (
            <div key={index} className="bg-white group/card flex flex-col rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
              {item.image && (
                <div className="h-48 aspect-video overflow-hidden ">
                  <img src={item.image} alt={item.title} className="w-full h-full group-hover/card:scale-105 transition-all object-cover" />
                </div>
              )}
              {item.videoUrl && item.type === "YouTube" && (
                <div className="relative h-48 aspect-video">
                  <iframe
                    width="100%"
                    height="100%"
                    src={item.videoUrl.replace("shorts/", "embed/").replace("watch?v=", "embed/")}
                    title={item.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              )}
              <div className="p-3 pt-5 flex-1 flex flex-col justify-between">
                <div>
                  <div className="flex items-center justify-between">
                    <div className="bg-primary1/10 rounded-full p-1">
                      <item.icon className="w-6 h-6 text-primary1" />
                    </div>
                    <div className="flex items-center mb-4 gap-1">
                      {item.tags
                        .filter(tag => tag !== "Featured") // Filter out the Featured tag
                        .map((tag, index) => (
                        <span
                          className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium
                    ${
                      tag === "New"
                        ? "bg-green-100 text-green-800"
                        : tag === "Video"
                        ? "bg-red-100 text-red-800"
                        : tag === "Case Study"
                        ? "bg-orange-100 text-orange-800"
                        : tag === "Updated"
                        ? "bg-blue-100 text-blue-800"
                        : tag === "Docs"
                        ? "bg-purple-100 text-purple-800"
                        : "bg-gray-100 text-gray-800"
                    }`}
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>

                  <h3 className="text-lg font-semibold mb-2">{item.title}</h3>
                  <p className="text-foreground-500 text-sm mb-4">{item.description}</p>
                </div>

                <div className="flex flex-wrap gap-3 ">
                  {item.actions.map((action, actionIndex) => (
                    <button
                      key={actionIndex}
                      onClick={() => {
                        window.open(action?.url, "_blank");
                      }}
                      className={`inline-flex items-center px-4 py-2 rounded-md text-xs font-medium transition-colors
                        ${
                          action.variant === "primary"
                            ? "bg-blue-600/20 text-blue-600 hover:bg-blue-600/30"
                            : action.variant === "secondary"
                            ? "bg-gray-100 text-gray-700 hover:bg-gray-200"
                            : action.variant === "youtube"
                            ? "bg-red-600/20 text-red-600 hover:bg-red-600/30"
                            : action.variant === "orange"
                            ? "bg-orange-600/20 text-orange-600 hover:bg-orange-600/30"
                            : action.variant === "purple"
                            ? "bg-purple-600/20 text-purple-600 hover:bg-purple-600/30"
                            : action.variant === "green"
                            ? "bg-green-600/20 text-green-600 hover:bg-green-600/30"
                            : "bg-gray-600/20 text-gray-600 hover:bg-gray-600/30"
                        }`}
                    >
                      {action.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export const WHATS_NEW_ITEMS = [

 // New Features (all recently added features)
 {
      type: "New",
      icon: PiRocketLaunchDuotone,
      tags: ["New", "Featured"],
      title: "Web Widget Gamification",
      description: "Gamification in web widget that boosts user engagement, sales and customer retention.",
      actions: [{ label: "View Guide", type: "link", variant: "primary", url: "https://help.yourgpt.ai/article/gamification-in-widget-to-enhance-engagement-during-human-escalation-2242" }],
      image: "images/gamification.png",
      featuredRank: 7,
    },
  {
    type: "New",
    icon: PiRocketLaunchDuotone,
    tags: ["New"],
    title: "Multilingual Dashboard",
    description: "YourGPT now supports 10+ languages in the dashboard for a more accessible experience.",
    actions: [{ label: "View Guide", type: "link", variant: "primary", url: "https://help.yourgpt.ai/article/how-to-configure-general-settings-in-yourgpt-chatbot-104" }],
    image: "images/multilingual-dashboard.png",
  },
  {
    type: "New",
    icon: PiRocketLaunchDuotone,
    tags: ["Featured", "New"],
    title: "MCP Integration",
    description: "Model Context Protocol (MCP) is an open standard that enables AI systems to communicate with external tools using a unified, secure, and scalable interface.",
    actions: [{ label: "Connect", type: "button", variant: "purple", url: "https://docs.yourgpt.ai/chatbot/integrations/mcp" }],
    image: "images/mcp.png",
    featuredRank: 6, 
  },
  {
    type: "New",
    icon: PiRocketLaunchDuotone,
    tags: ["New"],
    title: "WCAG Support",
    description: "Our widget meets accessibility standards so all your users get a smooth, inclusive experience.",
    actions: [{ label: "View Guide", type: "link", variant: "primary", url: "https://help.yourgpt.ai/article/how-to-configure-general-settings-in-yourgpt-chatbot-104" }],
    image: "images/wcag.png",
  },
  
  {
    type: "New",
    icon: PiRocketLaunchDuotone,
    tags: ["New"],
    title: "Contact CRM",
    description: "Easily manage contacts—import in bulk, tag them, and create custom fields—all in one view.",
    actions: [{ label: "View Guide", type: "link", variant: "primary", url: "https://help.yourgpt.ai/article/how-to-configure-general-settings-in-yourgpt-chatbot-104" }],
    image: "images/contact-crm.png",
  },
  {
    type: "New",
    icon: PiRocketLaunchDuotone,
    tags: ["New"],
    title: "Clone bot",
    description: "Easily clone your bot to create a production & staging environment.",
    actions: [{ label: "View Guide", type: "link", variant: "primary", url: "https://help.yourgpt.ai/article/how-to-configure-general-settings-in-yourgpt-chatbot-104" }],
    image: "images/clonebot.png",
  },
  
  // YouTube videos
  {
    type: "YouTube",
    icon: PiYoutubeLogoDuotone,
    tags: ["Video", "New"],
    title: "Web Widget Gamification",
    description: "Gamification in web widget that boosts user engagement, sales and customer retention.",
    actions: [{ label: "Watch on YouTube", type: "button", variant: "youtube", url: "https://youtube.com/shorts/Twgjr271GSk?si=br605IYS_VC7bcmm" }],
    videoUrl: "https://youtube.com/shorts/LfbZXUlBTeM",
  },
  {
    type: "YouTube",
    icon: PiYoutubeLogoDuotone,
    tags: ["Video", "New"],
    title: "Stripe Integration with your AI agent",
    description: "Integrate Stripe with your AI agent to handle payments and invoices.",
    actions: [{ label: "Watch on YouTube", type: "button", variant: "youtube", url: "https://youtube.com/shorts/Twgjr271GSk?si=br605IYS_VC7bcmm" }],
    videoUrl: "https://youtube.com/shorts/xB1cV6T58cc",
  },
  {
    type: "YouTube",
    icon: PiYoutubeLogoDuotone,
    tags: ["Featured", "Video", "New"],
    title: "Build your own voice AI Agent",
    description: "Voice AI Agent is a powerful tool that allows you to build your own voice AI agent.",
    actions: [{ label: "Watch on YouTube", type: "button", variant: "youtube", url: "https://youtube.com/shorts/Twgjr271GSk?si=br605IYS_VC7bcmm" }],
    videoUrl: "https://youtube.com/shorts/Twgjr271GSk?si=br605IYS_VC7bcmm",
    featuredRank: 8,
  },
  {
    type: "YouTube",
    icon: PiYoutubeLogoDuotone,
    tags: ["Video"],
    title: "AI Image Generation Business",
    description: "Create your own AI image generation business in 2025 with YourGPT.",
    actions: [{ label: "Watch on YouTube", type: "button", variant: "youtube", url: "https://www.youtube.com/watch?v=l1v-NY0giXk" }],
    videoUrl: "https://www.youtube.com/watch?v=l1v-NY0giXk",
  },
  {
    type: "YouTube",
    icon: PiYoutubeLogoDuotone,
    tags: ["Video"],
    title: "YourGPT x ResOs Integration",
    description: "Integrate ResOs with YourGPT to automate table reservation and improve customer experience.",
    actions: [{ label: "Watch on YouTube", type: "button", variant: "youtube", url: "https://www.youtube.com/watch?v=FkTxMV-LX3U" }],
    videoUrl: "https://www.youtube.com/watch?v=FkTxMV-LX3U",
  },
  {
    type: "YouTube",
    icon: PiYoutubeLogoDuotone,
    tags: ["Video"],
    title: "AI Chatbot for Shopify",
    description: "Integrate AI chatbot into your Shopify store to enhance customer support and increase sales.",
    actions: [{ label: "Watch on YouTube", type: "button", variant: "youtube", url: "https://www.youtube.com/embed/SdKAAQj0pzQ?si=rYUHKnkzdSPrTX6i" }],
    videoUrl: "https://www.youtube.com/embed/SdKAAQj0pzQ?si=rYUHKnkzdSPrTX6i",
  },

  // Resources (Templates, Case Studies, Docs, Help Center)
  {
    type: "Resources",
    icon: PiPlusCircleDuotone,
    tags: ["Integration"],
    title: "N8N Integration",
    description: "Official YourGPT integration for n8n – enables workflows to interact with the YourGPT AI chatbot.",
    actions: [{ label: "Integrate", type: "button", variant: "purple", url: "https://github.com/YourGPT/n8n-nodes-yourgpt" }],
    image: "images/n8n.png",
  },
  {
    type: "Resources",
    icon: PiPlusCircleDuotone,
    tags: ["Integration"],
    title: "PrestaShop Integration",
    description: "You can now integrate your AI agent with PrestaShop to provide a seamless experience for your customers.",
    actions: [{ label: "Integrate", type: "button", variant: "purple", url: "https://github.com/YourGPT/prestashop-chatbot-module" }],
    image: "images/prestashop.png",
  },
  {
    type: "Resources",
    icon: PiPlusCircleDuotone,
    tags: ["Integration"],
    title: "WooCommerce Sync",
    description: "You can now sync your WooCommerce orders with YourGPT to provide a seamless experience for your customers.",
    actions: [{ label: "Integrate", type: "button", variant: "purple", url: "https://help.yourgpt.ai/article/sync-woocommerce-with-yourgpt-using-webhooks-1842" }],
    image: "images/woocommerce-sync.png",
  },
  {
    type: "Resources",
    icon: PiNotebookDuotone,
    tags: ["Case Study"],
    title: "How Healthbird improved Patient Care with AI",
    description: "Discover how Healthbird transformed their patient care with AI, achieving 90% resolution rate.",
    actions: [{ label: "Read Case Study", type: "button", variant: "orange", url: "https://yourgpt.ai/customers/healthbird" }],
    image: "images/healthbird.png",
  },
  {
    type: "Resources",
    icon: PiPlusCircleDuotone,
    tags: ["New"],
    title: "Widget Theme Templates",
    description: "Customize your chat widget with our new theme templates. Choose styles that match your brand and boost user engagement.",
    actions: [{ label: "Visit Repo", type: "button", variant: "secondary", url: "https://github.com/YourGPT/chatbot-widget-templates" }],
    image: "images/themes.png",
  },
  {
    type: "Resources",
    icon: PiNotebookDuotone,
    tags: ["Case Study"],
    title: "SKNANB Transforms Banking with YourGPT AI",
    description: "How St Kitts Nevis Anguilla National Bank boosted customer service with 85% AI resolution rate.",
    actions: [{ label: "Read Case Study", type: "button", variant: "orange", url: "https://yourgpt.ai/customers/sknanb" }],
    image: "images/NB.png",
  },
  {
    type: "Resources",
    icon: PiPlusCircleDuotone,
    tags: ["New", "Studio Template"],
    title: "Connect and Sync Leads to Brevo",
    description: "Discover and implement pre-built AI assistant templates for your business needs.",
    actions: [{ label: "View Template", type: "button", variant: "secondary", url: "https://yourgpt.ai/template-library/brevo-connect-and-leads-sync-66a29cc508bbfa9bc5a6ecb1" }],
    image: "images/brevo.png",
  },
  {
    type: "Resources",
    icon: PiNotebookDuotone,
    tags: ["Case Study"],
    title: "Kimura Scales Document Processing with AI",
    description: "See how Kimura cut document processing time by 40% with our AI automation.",
    actions: [{ label: "Read Case Study", type: "button", variant: "orange", url: "https://yourgpt.ai/customers/kimura" }],
    image: "images/kimura.png",
  },
  {
    type: "Resources",
    icon: PiNotebookDuotone,
    tags: ["Case Study"],
    title: "Mageplaza Chooses YourGPT for AI Support",
    description: "How Mageplaza cut response times by 50% while boosting customer satisfaction with YourGPT.",
    actions: [{ label: "Read Case Study", type: "button", variant: "orange", url: "https://yourgpt.ai/customers/mageplaza" }],
    image: "images/mageplaza.png",
  },

  // Featured Updates 
  {
    type: "New",
    icon: PiRocketLaunchDuotone,
    tags: ["Featured", "Updated"],
    title: "AI Agent",
    description: "Create custom AI agents with no code using our AI Agent builder.",
    actions: [{ label: "View Guide", type: "link", variant: "primary", url: "https://help.yourgpt.ai/article/how-to-create-an-ai-chatbot-with-yourgpt-349" }],
    image: "images/ai-agent.png",
    featuredRank: 1, 
  },
  {
    type: "New",
    icon: PiRocketLaunchDuotone,
    tags: ["Featured", "New"],
    title: "AI Phone Agents",
    description: "Your phone AI agent can handle incoming and make outbound calls, with human escalation if needed.",
    actions: [{ label: "View Guide", type: "link", variant: "primary", url: "https://docs.yourgpt.ai/chatbot/integrations/voice/phone" }],
    image: "images/phone-agent.png",
    featuredRank: 2, 
  },
  {
    type: "New",
    icon: PiRocketLaunchDuotone,
    tags: ["Featured", "Updated"],
    title: "AI Studio",
    description: "Build and deploy powerful sequential AI agents with full control for your production use cases.",
    actions: [{ label: "View Guide", type: "link", variant: "primary", url: "https://docs.yourgpt.ai/chatbot/studio/elements/intents" }],
    image: "images/ai-studio.png",
    featuredRank: 3,  
  },
  {
    type: "New",
    icon: PiRocketLaunchDuotone,
    tags: ["Featured", "New"],
    title: "AI Helpdesk",
    description: "AI-powered helpdesk with knowledge management and self-service support for your users.",
    actions: [{ label: "Learn More", type: "link", variant: "primary", url: "https://help.yourgpt.ai" }],
    image: "images/ai-helpdesk.png",
    featuredRank: 4, 
  },
  {
    type: "New",
    icon: PiRocketLaunchDuotone,
    tags: ["Featured", "New"],
    title: "AI Search",
    description: "Add an AI-powered search widget to your website, Docs and knowledge base with our new widget.",
    actions: [{ label: "View Guide", type: "link", variant: "primary", url: "https://help.yourgpt.ai/article/adding-an-ai-search-widget-to-your-docs-site-or-app-1351" }],
    image: "images/ai-search-widget.png",
    featuredRank: 5,
  },


];


